module.exports = __webpack_public_path__ + "img/molecule-center.1cc57772.png";